import { companyStore } from '../stores/company.store';

export const useCompanyStore = () => companyStore;
